import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';

Vue.use(Vuex);


let favorites = window.localStorage.getItem('favorites');
if(favorites) {
    favorites = JSON.parse(favorites);
} else {
    favorites = [];
}

let diary = window.localStorage.getItem('diary');
if(diary) {
    diary = JSON.parse(diary);
} else {
    diary = [];
}

const state = {
    ready: false,
    menu: false,
    color:'',

    slug: '',
    back: '',
    menuItems: [],

    canAddToFavorites: false,
    favorite: null,
    favorites: favorites,

    diary: diary,

    page: {},
    pages: {},
};

const mutations = {
    ready(state, payload) {
        state.ready = payload == true;
    },
    menu(state, payload) {
        state.menu = payload == true;
    },
    menuItems(state, payload) {
        state.menuItems = payload;
    },
    slug(state, payload) {
        state.slug = payload;
    },
    back(state, payload) {
        state.back = payload;
    },
    color(state, payload) {
        state.color = payload;
    },
    updateFavorites(state) {
        state.canAddToFavorites = state.page.canAddToFavorites ? true : false;
        state.favorite = null;
        if(state.canAddToFavorites) {
            for(let favorite of state.favorites) {
                if(favorite.id == state.page.id) {
                    state.favorite = favorite;
                    break;
                }
            }
        }
    },
    addToFavorite(state) {
        const favorite = {
            id : state.page.id,
            slug : state.page.slug,
            parentSlug : state.page.parent ? state.page.parent.slug : null,
            title : state.page.title };

        state.favorites.push(favorite);
        state.favorite = favorite;

        window.localStorage.setItem('favorites', JSON.stringify(state.favorites));
    },
    removeFromFavorites(state) {
        if(state.favorite) {
            for(let index in state.favorites) {
                const favorite = state.favorites[index];
                if(favorite.id == state.favorite.id) {
                    state.favorites.splice(index, 1);
                    state.favorite = null;

                    window.localStorage.setItem('favorites', JSON.stringify(state.favorites));
                    return true;
                }
            }
        }
        return false;
    },
    addDiaryEntry(state, entry) {
        state.diary.push(entry);
        window.localStorage.setItem('diary', JSON.stringify(state.diary));
    },
    removeDiaryEntry(state, entry) {
        if(state.diary) {
            for(let index in state.diary) {
                if(state.diary[index] === entry) {
                    state.diary.splice(index, 1);
                    window.localStorage.setItem('diary', JSON.stringify(state.diary));
                    return true;
                }
            }
        }
        return false;
    },
    page(state, payload) {
        state.slug = payload.slug;
        state.page = payload.page;
        state.pages[payload.slug] = payload.page;
        state.back = "";
    },
};

const actions = {
    loading(context) {
        context.commit('ready', false);
    },
    loaded (context) {
        context.commit('ready', true);
    },
    toggleMenu (context) {
        context.commit('menu', context.state.menu ? false : true);
    },
    hideMenu (context) {
        context.commit('menu', false);
    },
    setColor(context, color) {
        context.commit('color', color);
    },
    /*slug (context, slug) {
        context.commit('slug', slug);
    },*/
    setBack (context, back) {
        context.commit('back', back);
    },
    canAddToFavorites(context, payload) {
        context.commit('canAddToFavorites', payload);
    },
    addToFavorite(context) {
        context.commit('addToFavorite');
    },
    removeFromFavorites(context) {
        context.commit('removeFromFavorites');
    },
    isFavorite(context) {
        context.commit('isFavorite');
    },
    addDiaryEntry(context, entry) {
        context.commit('addDiaryEntry', entry);
    },
    removeDiaryEntry(context, entry) {
        context.commit('removeDiaryEntry', entry);
    },
    async loadMenu(context) {
        try {
            let token = document.location.href.match(/\btoken=([^&]+)/);
            const url = token && token[1] ? ('?token=' + token[1]) : '';
            
            if(process.env.NODE_ENV == 'development') {
                window.console.log('get menu' + (url ? (' (' + url + ")") : ''));
            }

            const response = await axios({
                method: 'post', 
                url: url,
                data: {
                    query: `
                        query menu {
                            entries(section:"page") {
                                ...on page_page_Entry {
                                    id
                                    slug
                                    title
                                    color {
                                        label
                                        color
                                    }
                                    parent {
                                      id
                                      slug
                                    }
                                }
                            }
                        }
                    `}
                });

                let items = [];
                let itemIds = {};
                if(typeof response.data.data.entries != 'undefined') {
                    for(const page of response.data.data.entries) {
                        if(page.color && page.color.label) {
                            page.color = page.color.label;
                        }

                        if(page.parent && page.parent.id) {
                            const parentId = page.parent.id;
                            if(typeof itemIds[parentId] != 'undefined') {
                                if(!items[itemIds[parentId]].items) {
                                    items[itemIds[parentId]].items = [];
                                    items[itemIds[parentId]].expanded = false;
                                }
                                items[itemIds[parentId]].items.push(page);
                            }
                        }
                        else {
                            items.push(page);
                            itemIds[page.id] = items.length - 1;
                        }
                    }

                    context.commit('menuItems', items);
                }
        } catch (e) {
            window.console.log(e);
        }
    },
    async loadPage(context, slug) {
        try {
            let token = document.location.href.match(/\btoken=([^&]+)/);
            const url = token && token[1] ? ('?token=' + token[1]) : '';
        
            const query = slug != 'frontpage' ? 
                `query page { entries(section:"page", slug: "${slug}") {
                    ...on page_page_Entry {
                        id
                        slug
                        parent {
                            id
                            slug
                        }
                        title
                        audio {
                            id
                            url
                        }
                        color {
                            label
                            color
                        }
                        ageGroups {
                            title
                        }
                        artist
                        canAddToFavorites
                        blocks {
                            __typename
                            ...on blocks_text_BlockType {
                                text
                            }
                            ...on blocks_link_BlockType {
                                heading
                                page {
                                    id
                                    slug
                                    parent {
                                        id
                                        slug
                                    }
                                }
                            }
                            ...on blocks_popup_BlockType {
                                button
                                heading
                                text 
                            }
                            ...on blocks_image_BlockType {
                                image {
                                url
                                }
                                caption
                            }
                            ...on blocks_video_BlockType {
                                videoLink
                            }
                        }
                    }
                } }`
                : `query page { entries(section:"frontpage") {
                    ...on frontpage_frontpage_Entry {
                        id
                        slug
                        title
                        color {
                            label
                            color
                        }
                        blocks {
                            __typename
                            ...on blocks_text_BlockType {
                                text
                            }
                            ...on blocks_link_BlockType {
                                heading
                                page {
                                    id
                                    slug
                                    parent {
                                        id
                                        slug
                                    }
                                }
                            }
                            ...on blocks_popup_BlockType {
                                button
                                heading
                                text 
                            }
                            ...on blocks_image_BlockType {
                                image {
                                url
                                }
                                caption
                            }
                            ...on blocks_video_BlockType {
                                videoLink
                            }
                        }
                        blocksFavorites {
                            __typename
                            ...on blocksFavorites_text_BlockType {
                                text
                            }
                        }
                        blocksNoFavorites {
                            __typename
                            ...on blocksNoFavorites_text_BlockType {
                                text
                            }
                            ...on blocksNoFavorites_link_BlockType {
                                heading
                                page {
                                    id
                                    slug
                                    parent {
                                        id
                                        slug
                                    }
                                }
                            }
                        }                                        
                    }
                } }`;

            if(process.env.NODE_ENV == 'development') {
                window.console.log('get page ' + slug  + (url ? (' (' + url + ")") : ''));
                window.console.log(query);
            }

            // get page
            const response = await axios({
                method: 'post', 
                url: url,
                data: { query: query } });

            if(response.data && response.data.data && response.data.data.entries && response.data.data.entries.length) {

                const page = response.data.data.entries[0];

                if(page.color && page.color.label) {
                    page.color = page.color.label;
                }

                if(process.env.NODE_ENV == 'development') {
                    window.console.log(page);
                }

                context.commit('page', {
                    'slug': slug,
                    'page': page
                });

                context.commit('updateFavorites');
            }
            else if(response.data && response.data.errors) {
                window.console.log(response.data.errors);
            }

        } catch (e) {
            window.console.log(e);
        }
    }

};

export default () => { return new Vuex.Store({state, actions, mutations}); };
